import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { SiteKeys } from '@on3/ui-lib/utils/constants';
import { ConnatixPlayer } from '@public/components/Ads/ConnatixPlayer/ConnatixPlayer';
import { ExcoPlayer } from '@public/components/Ads/ExcoPlayer/ExcoPlayer';
import { StnPlayer } from '@public/components/Ads/StnPlayer';

enum VideoPlayerType {
  Exco = 'ExcoPlayer',
  Connatix = 'ConnatixPlayer',
  Stn = 'StnPlayer',
}

//Kansas State - No videos in playlist
const NORTH_CAROLINA = [SiteKeys.NorthCarolina, SiteKeys.InsideCarolina];
const KANSAS_STATE = [SiteKeys.KansasState, SiteKeys.KStateOnline];
const MICHIGAN_STATE = [SiteKeys.MichiganState, SiteKeys.SpartanMag];
const PENN_STATE = [SiteKeys.PennState, SiteKeys.BWI];
const NOTRE_DAME = [SiteKeys.NotreDame, SiteKeys.BlueAndGold];
const USC = [SiteKeys.USC, SiteKeys.WeAreSC];
const PURDUE = [SiteKeys.Purdue, SiteKeys.GoldAndBlack];
const FLORIDA_STATE = [SiteKeys.FloridaState, SiteKeys.Warchant];
const FLORIDA = [SiteKeys.Florida, SiteKeys.GatorsOnline];
const MICHIGAN = [SiteKeys.Michigan, SiteKeys.TheWolverine];
const TENNESSEE = [SiteKeys.Tennessee, SiteKeys.Volquest];
const SMU = [SiteKeys.SMU, SiteKeys.OnThePonyExpress];
const MIAMI = [SiteKeys.Miami, SiteKeys.CaneSport];
const NEBRASKA = [SiteKeys.Nebraska, SiteKeys.HuskerOnline];
const SOUTH_CAROLINA = [SiteKeys.SouthCarolina, SiteKeys.GamecockCentral];

const excoSites = [
  ...NORTH_CAROLINA,
  ...KANSAS_STATE,
  ...MICHIGAN_STATE,
  ...PENN_STATE,
  ...NOTRE_DAME,
  ...USC,
  ...PURDUE,
  ...FLORIDA_STATE,
  ...FLORIDA,
  ...MICHIGAN,
  ...TENNESSEE,
  ...SMU,
  ...MIAMI,
  ...NEBRASKA,
  ...SOUTH_CAROLINA,
];

const stnSites = [SiteKeys.FiveGOATs];

export const VideoPlayer = () => {
  const { currentSite } = useSite();

  let selectedPlayer: VideoPlayerType = VideoPlayerType.Connatix;

  if (excoSites.includes(currentSite.key)) {
    selectedPlayer = VideoPlayerType.Exco;
  }

  if (stnSites.includes(currentSite.key)) {
    selectedPlayer = VideoPlayerType.Stn;
  }

  return (
    <>
      {selectedPlayer === VideoPlayerType.Exco && <ExcoPlayer />}
      {selectedPlayer === VideoPlayerType.Connatix && <ConnatixPlayer />}
      {selectedPlayer === VideoPlayerType.Stn && <StnPlayer />}
    </>
  );
};
